import React from 'react';
import Cta from '@components/mir-cta/Cta';

const HomeCTA = ({ cta }) => {
  return (
    <Cta data={cta}/>
  );};

export default HomeCTA;
